import _ from "underscore";
import $ from "jquery";
import Backbone from "backbone";
import "../../../Assets/javascripts/nav/others/jquery.comboToList.js";

export default Backbone.View.extend({
    /*
     * @class StrateMacView
     *
     * @augments Backbone.View
     * @constructs
     */

    initialize: function () {
      /*
      $selectors
      */
      this.$gender = this.$el.find(".js-GenderSelect");
      this.$price = this.$el.find(".js-priceSelect-combo").find("select");
      this.$currentProfil = this.$el.find(".js-currentProfilSelect");
      this.$initialProfil = this.$el.find(".js-profileSelect-combo.isActive");
      this.$form = this.$el.find("form")
      /*
      init global values
      */
      this.currentGenderValue = this.$gender.children(":selected").attr("value");
      this.currentPriceValue = this.$price.children(":selected").attr("value");
      this.formAction = this.$form.attr("action");
      this.currentProfileValue = "";
      /*
      render the initial profile state
      */
      this.showProfileCombo();
      /*
      Events for combo to list
      */
      this.updateCurrentGenderValue = this.updateCurrentGenderValue.bind(this);
      this.updateCurrentProfileValue = this.updateCurrentProfileValue.bind(this);
      this.updateCurrentPriceValue = this.updateCurrentPriceValue.bind(this);
      this.showProfileCombo = this.showProfileCombo.bind(this);
      this.hideProfileCombo = this.hideProfileCombo.bind(this);

      this.$el.find("select.js-PriceSelect").comboToList({
        onChange: this.updateCurrentPriceValue
      });

      this.$el.find("select.js-ProfileSelect").comboToList({
        onChange: this.updateCurrentProfileValue
      });

      this.$el.find("select.js-GenderSelect").comboToList({
        onChange: this.updateCurrentGenderValue
      });

    },
    /*
    - Gender combo select to update the current coresponding profile
    - Submit Form event to build the right url
    */
    events: {
      "click .js-GenderSelect-combo li": "updateCurrentGenderValue",
      "submit .js-StrateMacView-form": "submitForm"
    },
    /*
    Submit Form Function (first build args + encode uri)
    */
    submitForm: function () {
      var args = "page=1;" + "filters=" + this.currentProfileValue + "," + this.currentPriceValue + ";" + "args=";
      url = "_stateValue=" + encodeURIComponent(args);
      this.$form.attr("action", this.formAction + "#" + url);
    },
    /*
    Update the price selected value
    */
    updateCurrentPriceValue: function (param) {
      this.currentPriceValue = param;
    },
    /*
    Update the current profile value
    */
    updateCurrentProfileValue: function (param) {
      this.currentProfileValue = param;
    },
    /*
    Update the current gender value
    hide the profile combo & show the selected one
    */
    updateCurrentGenderValue: function (param) {
      this.currentGenderValue = param;
      this.hideProfileCombo();
      this.showProfileCombo();
    },
    /*
    Initial render Profile combo
    TODO : Find a better way to update the new Profile value combo (using updateCurrentProfileValue function)
    */
    showProfileCombo: function () {
      this.$el.find(".js-profileSelect-combo#bloc_" + this.currentGenderValue).css("display", "inline-block").addClass("isActive");
      this.currentProfileValue = this.$el.find(".js-profileSelect-combo#bloc_" + this.currentGenderValue).find("select").children(":selected").attr("value");
    },

    /*
    Hide all the profile combo 
    TODO : need condition to aim only the one selected
    */
    hideProfileCombo: function(){
      this.$el.find(".js-profileSelect-combo").removeClass("isActive").css("display", "none");;
    },

  });
